console.log(`${process.env.VUE_APP_ENV} ${process.env.VUE_APP_VERSION} \n\n`);
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import i18n from './i18n';
import store from './store';
import './plugins/govmo';
// import './plugins/element-ui';
// import './plugins/meta-ui';
import './meta-variables.scss';
import './styles/base.scss';
import './app.scss';
// import { getErrorMessage } from '@metaarchit/common-utils/lib/error';
// import { Loading, Message, MessageBox } from 'element-ui';
import getValue from 'lodash/get';
import MessagePlugin from 'common/plugins/message/web';

import AxiosPlugin from './plugins/axios';
Vue.config.productionTip = false;
document.querySelector('html').classList.add('theme--ab');

// 全局属性
Vue.prototype.$localized = function (obj, keypath = 'name', defLocale = 'Cn') {
  const locale =
    ['Cn', 'Pt', 'En'][['zh-Hant', 'pt', 'en'].indexOf(i18n.locale)] ||
    defLocale;
  return getValue(obj, `${keypath}${locale}`);
};

Vue.use(AxiosPlugin, {
  requestInterceptor(config) {
    //設置多語言
    const lan = i18n.t('Common.message.lang') || 'ZH_HANT';
    config.headers['Language'] = lan;
    return config;
  },
  async responseInterceptor(config) {
    return config;
  },
  beforeError({ response }) {
    console.log(response);
  },
});

Vue.use(MessagePlugin, { i18n });

new Vue({
  router,
  i18n,
  store,
  render: (h) => h(App),
}).$mount('#app');
